import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';

const SearchBar = ({ value, setValue, onSubmit, className, autoSubmit }) => {
  const [searchTimeout, setSearchTimeout] = useState(null);
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };

  useEffect(() => {
    console.log(value);
    if (autoSubmit) {
      if (searchTimeout) clearTimeout(searchTimeout);
      const timeout = setTimeout(onSubmit, 500);
      setSearchTimeout(timeout);
    }
  }, [value]);

  return (
    <form onSubmit={handleSubmit} className={'flex gap-3 ' + (className || '')}>
      <input
        type='text'
        placeholder='Buscar...'
        onChange={(e) => setValue(e.target.value)}
        value={value}
        className='transition-colors border-2 max-w-[500px] w-full rounded h-10 leading-10 focus:border-red-2 focus:outline-none pl-3'
      />
      <button type='submit' className='h-10 w-10 rounded-xl bg-gray-100 focus:bg-red-100 hover:bg-red-100 transition-colors hover:text-red-2'>
        <FontAwesomeIcon icon={faMagnifyingGlass} />
      </button>
    </form>
  );
};

export default SearchBar;
